import unset from "./unset";

/**
 * Get all object data except for the given keys
 *
 * @param {any} object
 * @param {string[]} keys
 * @returns {any}
 */
export default function except(object: object, keys: string[]): any {
    const newObject = { ...object };

    return unset(newObject, keys);
}
